import React, { useState } from 'react';
import { OptionContents } from './OptionContents.containers';
import { TDPKContents } from './TDPKContents.containers';
import { Col, Row } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { hotelActions } from 'features/hotel/actions';

export const TDPKFloorPlan = () => {
  const dispatch = useDispatch();

  const [airStatusChecked, setAirStatusChecked] = useState(true);
  const [envStatusChecked, setEnvStatusChecked] = useState(true);
  const [airIconChecked, setAirIconChecked] = useState(true);
  const [envIconChecked, setEnvIconChecked] = useState(true);
  const [secIconChecked, setSecIconChecked] = useState(true);

  const handleChangeAirStatus = () => {
    setAirStatusChecked(!airStatusChecked);
  };

  const handleChangeEnvStatus = () => {
    setEnvStatusChecked(!envStatusChecked);
  };

  const handleChangeAirIcon = () => {
    setAirIconChecked(!airIconChecked);
  };

  const handleChangeEnvIcon = () => {
    setEnvIconChecked(!envIconChecked);
  };

  const handleChangeSecIcon = () => {
    setSecIconChecked(!secIconChecked);
  };

  dispatch(hotelActions.getAllDevices('6C1', 'Pegasus'));

  return (
    <div className="content">
      <Row>
        <Col lg="10" md="12" sm="12">
          <TDPKContents />
        </Col>
        <Col lg="2" md="12" sm="12" style={{ marginTop: '3%' }}>
          <OptionContents
            airStatusChecked={airStatusChecked}
            envStatusChecked={envStatusChecked}
            handleChangeAirStatus={handleChangeAirStatus}
            handleChangeEnvStatus={handleChangeEnvStatus}
            airIconChecked={airIconChecked}
            envIconChecked={envIconChecked}
            secIconChecked={secIconChecked}
            handleChangeAirIcon={handleChangeAirIcon}
            handleChangeEnvIcon={handleChangeEnvIcon}
            handleChangeSecIcon={handleChangeSecIcon}
          />
        </Col>
      </Row>
    </div>
  );
};
